import React from "react";
import { Navigate } from "react-router-dom";
import { clearSession, getStoredUser, isTokenExpired } from "./utils/session";

export default function RequireAuth({ children }) {
  const user = getStoredUser();
  // No basta con que exista el usuario en localStorage: si el token ya vencio
  // la pantalla entra igual y todas las peticiones responden 403 en silencio.
  if (!user || !user.token || isTokenExpired(user.token)) {
    clearSession();
    return <Navigate to="/login" />;
  }
  return children;
}
